import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import store from "@/store";
import { Http } from "@status/codes";
import cloneDeep from "lodash/cloneDeep";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import {
  DASHBOARD_TEMPLATE_EVENTS,
  DASHBOARD_TEMPLATE_MESSAGES,
  INDICATOR,
  TAG
} from "../../constants/DashboardTemplatesConstants";
import { CollectionFilter } from "../../models/CollectionFilter";
import { Field } from "../../models/Field";
import { IndicatorOrTag } from "../../models/IndicatorOrTag";
import { Query } from "../../models/Query";
import { SectionOfDashboard } from "../../models/SectionOfDashboard";
import { ViewsConfigResponse } from "../../models/viewsConfigResponse";
import { BqDashboardService } from "../../services/BqDashboardService";
import CollectionOfSection from "../CollectionOfSection/CollectionOfSection.vue";
import DashboardFilter from "../DashboardFilter/DashboardFilter.vue";
import Indicator from "../IndicatorModal/Indicator.vue";
import TagsOfSection from "./TagsOfSection/TagsOfSection.vue";
@Component({
  name: "SectionsOfdashboard",
  components: {
    DashboardFilter,
    DynamicSelect,
    CollectionOfSection,
    Indicator,
    TagsOfSection
  },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      refreshtags: "getRefreshTags",
      refreshIndicators: "getRefreshIndicators",
      disabledAddCollectionFilterButton: "getDisabledAddCollectionFilterButton"
    })
  }
})
export default class SectionsOfdashboard extends Vue {
  @Inject() bqDashboardService!: BqDashboardService;

  @Prop() indexSectionOfDashboard!: number;
  @Prop() sectionOfDashboard!: SectionOfDashboard;
  @Prop() collectionsData!: ViewsConfigResponse[];

  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  disabledAddCollectionFilterButton!: boolean;

  refreshtags!: number;
  refreshIndicators!: number;
  addItem = GENERAL_CONSTANTS.ICONS.ADD;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  sectionName = "";
  collections: Array<CollectionFilter> = [];
  collectionsOptions: { id: string; name: string; fields: Field[] }[] = [];
  indicatorModal = false;
  optionsToIndicator: DynamicSelectData[] = [];
  storeCollectionsOptions: { id: string; name: string; fields: Field[] }[] = [];
  tagOrIndicator = "";
  tags: IndicatorOrTag[] = [];
  indicators: IndicatorOrTag[] = [];
  selectedTags = [];
  mainCollection = "";
  disabledAddCollectionFilterButtonLocal = true;
  elementToEdit: IndicatorOrTag = {
    indicatorOrTagName: "",
    tagOrIndicator: "",
    show: false
  };
  loading = false;
  editCase = false;

  mounted() {
    this.preload();
  }

  preload() {
    console.log("preload");

    this.sectionName = this.sectionOfDashboard.name;
    this.collections = cloneDeep(this.sectionOfDashboard.collections || []);

    this.getCollectionsToMakeQuery();
    this.storeCollectionsOptions = cloneDeep(
      this.sectionOfDashboard.collectionsOptions
    );
    this.collectionsOptions = this.sectionOfDashboard.collectionsOptions || [];
    this.mainCollection =
      this.sectionOfDashboard.collections?.[0]?.collection?.[0]?.id || "";
    const collectionsSize = this.collections.length;
    const lastcollection = this.collections[collectionsSize - 1];

    if (
      lastcollection &&
      lastcollection.query &&
      Object.values(this.collections[collectionsSize - 1].query as Query)
        .length > 0
    ) {
      this.getOptionsToIndicator();
    }
    this.handlerIndicatorsSet(this.sectionOfDashboard.indicators || []);
    this.handlerTagsSet(this.sectionOfDashboard.tags || []);
    this.preloadTags(this.tags);
  }

  preloadTags(tags: IndicatorOrTag[]) {
    for (const [index, tag] of Object.entries(tags)) {
      let callPreloadIndicatorFunction = false;
      if (Number(index) == tags.length - 1) {
        callPreloadIndicatorFunction = true;
      }
      this.editCase = true;
      this.calculateTag(tag, true, callPreloadIndicatorFunction);
    }
  }

  cleanElementToEdit() {
    this.elementToEdit = {
      indicatorOrTagName: "",
      tagOrIndicator: "",
      show: false
    };
  }

  @Watch("sectionOfDashboard", { deep: true })
  onSectionOfDashboardChange() {
    console.log("onSectionOfDashboardChange", {
      sectionOfDashboard: this.sectionOfDashboard.collections,
      sectionOfDashboardLength: this.sectionOfDashboard.collections.length,
      collections: this.collections.length
    });

    if (
      JSON.stringify(this.tags) !== JSON.stringify(this.sectionOfDashboard.tags)
    ) {
      this.verifyAndUpdateTags();
    }
    this.sectionName = this.sectionOfDashboard.name;
    this.getOptionsToIndicator();

    if (
      this.sectionOfDashboard.collections.length == this.collections.length ||
      this.sectionOfDashboard.collections.length < this.collections.length
    ) {
      console.log("son iguales en tamaño");
      return;
    }

    const collectionsCopy = cloneDeep(this.sectionOfDashboard.collections);

    console.log("hara push");
    this.collections.push(collectionsCopy[collectionsCopy.length - 1]);
    console.log("collections", this.collections);

    this.collectionsOptions = this.sectionOfDashboard.collectionsOptions || [];
    this.mainCollection =
      this.sectionOfDashboard.collections?.[0]?.collection?.[0]?.id || "";
  }

  get addTagButton() {
    const collections = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections.map(item => item.collection[0].name);
    return !collections.some(c => c);
  }

  deleteCollection(indexCollection: number) {
    console.log("deleteCollection", indexCollection);
    if (indexCollection == this.collections.length - 1) {
      this.collections.splice(indexCollection, 1);
      return;
    }

    this.collections = cloneDeep(this.sectionOfDashboard.collections);
  }

  @Watch("disabledAddCollectionFilterButton")
  onDisabledAddCollectionFilterButtonChange() {
    console.log(
      "onDisabledAddCollectionFilterButtonChange",
      this.disabledAddCollectionFilterButton
    );

    this.disabledAddCollectionFilterButtonLocal = this.disabledAddCollectionFilterButton;
  }

  @Watch("refreshtags")
  verifyAndUpdateTags() {
    this.tags = cloneDeep(this.sectionOfDashboard.tags || []);
    this.sectionOfDashboard.indicators.forEach(indicator => {
      console.log("indicator", indicator);

      this.calculateIndicator(indicator, true);
    });
  }
  @Watch("refreshIndicators")
  verifyAndUpdateIndicators() {
    this.indicators = cloneDeep(this.sectionOfDashboard.indicators || []);
  }
  getOptionsToIndicator() {
    console.log("getOptionsToIndicator", this.collections);

    const collections = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections.map(item => item.collection[0].name);
    console.log("collections", collections);

    const collectionsOptions = this.storeCollectionsOptions.filter(
      collectionOptions => {
        console.log("collectionOptions.name", collectionOptions.name);
        return collections.includes(collectionOptions.name);
      }
    );
    console.log("collectionsOptions", collectionsOptions);
    collectionsOptions.forEach(collection => {
      collection.fields.forEach(field => {
        this.optionsToIndicator.push({
          id: field.field,
          name: field.visualField,
          type: field.type,
          list: field.list,
          operators: field.operators,
          collection: { id: collection.id, name: collection.name }
        });
      });
    });
  }

  addCollectionFilter() {
    //    this.disabledAddCollectionFilterButtonLocal = true;
    store.commit("setDisabledAddCollectionFilterButton", true);

    store.commit(
      DASHBOARD_TEMPLATE_EVENTS.ADD_COLLECTION_TO_SECTION_OF_DASHBOARD,
      {
        index: this.indexSectionOfDashboard,
        collection: { collection: [{ id: "", name: "" }], filters: [] }
      }
    );
  }

  @Watch("sectionName")
  onSectionNameChange() {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_SECTION_NAME_OF_DASHBOARD, {
      index: this.indexSectionOfDashboard,
      name: this.sectionName
    });
  }

  deleteSectionOfDashboard() {
    store.commit(
      DASHBOARD_TEMPLATE_EVENTS.DELETE_SECTION_OF_DASHBOARD,
      this.indexSectionOfDashboard
    );
  }

  getCollectionsToMakeQuery() {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_COLLECTIONS_OPTIONS, {
      index: this.indexSectionOfDashboard,
      collectionsOptions: this.collectionsData
    });
  }

  addIndicator(element: string) {
    this.cleanElementToEdit();
    this.tagOrIndicator = element;
    this.indicatorModal = true;
  }

  async closeIndicatorModal(event: IndicatorOrTag) {
    console.log("event", { event, elementToEdit: this.elementToEdit });
    this.indicatorModal = false;
    if (!event) {
      this.cleanTagOrIndicatatorToEdit();
      return;
    }
    if (this.verifyIfItemChange(this.elementToEdit, event)) {
      this.cleanTagOrIndicatatorToEdit();
      return;
    }

    if (event.tagOrIndicator === INDICATOR) {
      this.calculateIndicator(event);
      this.cleanTagOrIndicatatorToEdit();
      return;
    }

    if (
      event.tagOrIndicator === TAG &&
      event.operation &&
      event.fieldToOperate
    ) {
      if (this.elementToEdit.indicatorOrTagName != event.indicatorOrTagName) {
        const indicators = this.indicators.map(i => {
          const formulaToCreateIndicator = i.formulaToCreateIndicator?.map(f =>
            f[0].id == this.elementToEdit.indicatorOrTagName
              ? [
                  {
                    id: event.indicatorOrTagName,
                    name: event.indicatorOrTagName
                  }
                ]
              : f
          );
          return { ...i, formulaToCreateIndicator };
        });
        this.handlerIndicatorsSet(indicators);
      }
      await this.calculateTag(event);
      this.cleanTagOrIndicatatorToEdit();
    }
  }

  calculateIndicator(event: IndicatorOrTag, preload?: boolean) {
    let formula = "";
    event.formulaToCreateIndicator!.forEach((item, index) => {
      const idItem = Array.isArray(item) ? item[0]["id"] : item.id;
      if (index == 1) {
        formula = formula + idItem;
      } else {
        const tag = this.tags.find(tag => tag.indicatorOrTagName == idItem);
        if (tag) {
          formula = formula + tag.value!.toString();
        }
      }
    });

    event.value = eval(formula).toFixed(2);

    let index = 0;
    if (preload) {
      index = this.indicators.findIndex(
        indicator => indicator.indicatorOrTagName == event.indicatorOrTagName
      );
    } else if (this.elementToEdit.value) {
      index = this.indicators.findIndex(
        indicator =>
          indicator.indicatorOrTagName == this.elementToEdit.indicatorOrTagName
      );
    }
    const action =
      index < 0
        ? DASHBOARD_TEMPLATE_EVENTS.ADD_INDICATOR
        : DASHBOARD_TEMPLATE_EVENTS.UPDATE_INDICATOR;

    this.handlerIndicatorEvent(action, event, index);
  }

  handlerIndicatorEvent(
    event: string,
    indicator: IndicatorOrTag,
    index: number
  ) {
    switch (event) {
      case DASHBOARD_TEMPLATE_EVENTS.ADD_INDICATOR:
        //this.indicators.push(indicator);
        break;

      case DASHBOARD_TEMPLATE_EVENTS.UPDATE_INDICATOR:
        if (index !== -1) {
          this.indicators[index] = indicator;
        }
        break;

      case DASHBOARD_TEMPLATE_EVENTS.DELETE_INDICATOR:
        if (index !== -1) {
          //this.indicators.splice(index, 1);
        }
        break;

      default:
        console.error("NOT HANDLER EVENT", event);
        return;
    }

    this.$store.commit(event, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      index,
      indicator: cloneDeep(indicator)
    });
  }
  handlerIndicatorsSet(indicators: IndicatorOrTag[]) {
    this.$store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_INDICATORS, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indicators: cloneDeep(indicators)
    });
    this.indicators = indicators;
  }

  handlerTagEvent(event: string, tag: IndicatorOrTag, index: number) {
    switch (event) {
      case DASHBOARD_TEMPLATE_EVENTS.ADD_TAG:
        //this.tags.push(indicator);
        break;

      case DASHBOARD_TEMPLATE_EVENTS.UPDATE_TAG:
        if (index !== -1) {
          this.tags[index] = tag;
        }
        break;

      case DASHBOARD_TEMPLATE_EVENTS.DELETE_TAG:
        if (index !== -1) {
          //this.tags.splice(index, 1);
        }
        break;

      default:
        console.error("NOT HANDLER EVENT", event);
        return;
    }

    this.$store.commit(event, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      index,
      tag: cloneDeep(tag)
    });
  }
  handlerTagsSet(tags: IndicatorOrTag[]) {
    this.$store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_TAGS, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      tags: cloneDeep(tags)
    });
    this.tags = tags;
  }

  async calculateTag(
    tag: IndicatorOrTag,
    preload = false,
    callPreloadIndicatorFunction?: boolean
  ) {
    let lastCollectionQuery: Query = {
      selectFields: {
        fields: [],
        agregations: []
      },
      principalView: "",
      filters: [],
      groupFields: []
    };
    if (preload) {
      lastCollectionQuery = tag.query as Query;
    } else {
      const collectionsSize = this.sectionsOfDashboardStore[
        this.indexSectionOfDashboard
      ].collections.length;
      lastCollectionQuery = cloneDeep(
        this.sectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
          collectionsSize - 1
        ]?.query
      ) as Query;
      lastCollectionQuery.selectFields.agregations.push({
        type: (tag.operation as { id: string; name: string }[])![0].id,
        view: tag.fieldToOperate![0].collection!.id,
        field: tag.fieldToOperate![0].id,
        alias: tag.fieldToOperate![0].id
      });
      lastCollectionQuery!.groupFields = [];
      lastCollectionQuery.principalView = tag.fieldToOperate![0].collection!.id;
    }

    this.loading = true;
    const dataToChartResponse = await this.bqDashboardService.getDataToChart(
      lastCollectionQuery
    );

    if (dataToChartResponse.code == Http.Found) {
      this.loading = false;
      dataToChartResponse.data[0].docId;
      tag.value = Number(
        (Object.values(dataToChartResponse.data[0])[0] as number).toFixed(2)
      );
      tag.query = lastCollectionQuery;
      console.log(tag);
      if (this.elementToEdit.indicatorOrTagName) {
        this.updateTag(tag);
        return;
      }

      if (preload) {
        this.updateTagWhenIsPreloading(tag, callPreloadIndicatorFunction);
        return;
      }

      this.handlerTagEvent(DASHBOARD_TEMPLATE_EVENTS.ADD_TAG, tag, 0);
    }
    this.loading = false;
  }

  updateTag(event: IndicatorOrTag) {
    const index = this.tags.findIndex(
      tag => tag.indicatorOrTagName == this.elementToEdit.indicatorOrTagName
    );

    this.handlerTagEvent(DASHBOARD_TEMPLATE_EVENTS.UPDATE_TAG, event, index);
  }

  updateTagWhenIsPreloading(
    event: IndicatorOrTag,
    callPreloadIndicatorFunction?: boolean
  ) {
    const index = this.tags.findIndex(
      tag => tag.indicatorOrTagName == event.indicatorOrTagName
    );

    this.handlerTagEvent(DASHBOARD_TEMPLATE_EVENTS.UPDATE_TAG, event, index);

    if (callPreloadIndicatorFunction) {
      this.preloadIndicators();
    }
  }

  preloadIndicators() {
    this.indicators.forEach(indicator => {
      this.calculateIndicator(indicator, true);
    });
  }

  editIndicator(index: number) {
    this.tagOrIndicator = INDICATOR;
    this.elementToEdit = this.indicators[index];
    this.indicatorModal = true;
  }

  editTag(index: number) {
    this.tagOrIndicator = TAG;
    this.elementToEdit = this.tags[index];
    this.indicatorModal = true;
  }

  deleteTag(index: number) {
    const tag = this.tags[index];
    for (const indicator of this.indicators) {
      for (const item of indicator.formulaToCreateIndicator!) {
        const idItem = Array.isArray(item) ? item[0]["id"] : item.id;

        if (idItem == tag.indicatorOrTagName) {
          Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.TAG_IN_USE);
          return;
        }
      }
    }

    this.handlerTagEvent(
      DASHBOARD_TEMPLATE_EVENTS.DELETE_TAG,
      this.tags[index],
      index
    );
  }

  toggleTag(index: number) {
    const tag = this.tags[index];
    this.handlerTagEvent(
      DASHBOARD_TEMPLATE_EVENTS.UPDATE_TAG,
      { ...tag, show: !tag.show },
      index
    );
  }

  toggleIndicator(index: number) {
    const indicator = this.indicators[index];
    this.handlerIndicatorEvent(
      DASHBOARD_TEMPLATE_EVENTS.UPDATE_INDICATOR,
      { ...indicator, show: !indicator.show },
      index
    );
  }

  deleteIndicator(index: number) {
    this.handlerIndicatorEvent(
      DASHBOARD_TEMPLATE_EVENTS.DELETE_INDICATOR,
      this.indicators[index],
      index
    );
  }

  cleanTagOrIndicatatorToEdit() {
    this.elementToEdit = {
      indicatorOrTagName: "",
      tagOrIndicator: "",
      show: false
    };
  }

  verifyIfItemChange(tagToEdit: IndicatorOrTag, event: IndicatorOrTag) {
    const cloneTagToEdit = cloneDeep(tagToEdit);
    delete cloneTagToEdit.value;
    return JSON.stringify(cloneTagToEdit) === JSON.stringify(event);
  }
}
